export default "__VITE_ASSET__C1w_WEX4__"